export default "__VITE_ASSET__C3aRbPSm__$_?assetResource__"